import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';


class AddRice extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  HandleChange = e => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    console.log(this.state);
  };
  handleSubmit = (e) => {
    e.preventDefault()
    console.log('Submitted')
    axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {

        'action': 'createRiceType',
        'data': this.state,

      }
    ).then(res => {
      console.log(res);
      this.props.history.push('/admin')
    })
  }
  render() {
    return (
      <Container>
        <form onSubmit={this.handleSubmit}>
          <Link to="AdminSys">back</Link>
          <h1 id="label1">Add Rice Type</h1>
          <label id="label">ชื่อพันธ์ข้าว(ภาษาไทย)</label>
          <input id="riceTypeNameTH" type="text" className="inputText" placeholder="Name" onChange={this.HandleChange}></input>
          <label id="label">ชื่อพันธ์ข้าว(ภาษาอังกฤษ)</label>
          <input id="riceTypeNameEN" type="text" className="inputText" placeholder="Name" onChange={this.HandleChange}></input>
          <label id="label">คำอธิบาย</label>
          <input id="riceTypeDescription" type="text" className="inputDescription" placeholder="Description" onChange={this.HandleChange}></input>
          <Button variant="danger" id="addOffice">cancel</Button>
          <Button variant="outline-success" id="addOffice" type="submit">Add</Button>
        </form>

      </Container>
    )
  }
}

export default AddRice;
